var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageViewChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(180 24 24)",
    fill: "#7D7D7D",
    fillOpacity: 0.42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1597 31.4844L19.0629 24.3876L26.1597 17.2908",
    stroke: "white",
    strokeWidth: 2.66129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageViewChevronLeft);
export default __webpack_public_path__ + "static/media/image-view-chevron-left.ca1cebebc9c4901029b615fec9b79a68.svg";
export { ForwardRef as ReactComponent };